﻿
import {ValidationMessageType} from "./validationMessageType";

export class ValidationMessage {
    message: string;
    propertyName: string;
    entityId: number;
    messageType: ValidationMessageType;
}